<template>
  <div class="contentDiv">
    <div class="cover scrollable-div">
      <HeaderContainer :active-index="currentMenuIndex" @menu-select="onMenuSelect"/>

      <el-row :gutter="20" style="margin-left: 0px; margin-right: 0px;width: 1170px">
        <!-- 大屏幕: 左侧30%/右侧70% -->
        <!-- 小屏幕: 堆叠显示 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="padding: 0px">
          <div class="responsive-left">
            <div class="news_end fl fm690 " style="overflow:hidden">
              <div class="deep_blue_box fl fm690">



                <div class="list_ti" v-for="(item, index) in newData" :key="index">

                  <div class="lst">
                    <dl>
                      <dt><a @click="hrefNoticeUrl(item)"   title="澳參與發展規劃為旅遊休閒帶來新機遇">{{ item.title }}</a></dt>
                      <dd></dd>
                    </dl>
                    <p class="lst01" style="margin: 0px">{{ item.title_content }}</p>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </el-col>

      </el-row>


      <footer>
        <div class="foot_con pub_case pure">
          <div class="link_foo">
            <a href="" target="_blank">聯繫我們</a> |
            <a href="" target="_blank">反饋意見</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">免責聲明</a> |
            <a href="" target="_blank">網頁指南</a> |
          </div>
          <div class="copyRight at_on">
            @2011 澳門銀河娛樂有限公司版權所有 不得轉載
          </div>
        </div>
      </footer>
    </div>
  </div>

</template>

<script>

import HeaderContainer from "@/components/HeaderContainer.vue";

export default {
  name: 'NewsNotice',
  components: {HeaderContainer},
  data() {
    return {
      currentMenuIndex: '4', // 根据当前路由设置: 1,
      newData:[
        {
          title:"澳參與發展規劃為旅遊休閒帶來新機遇",
          title_content:"澳門旅遊、酒店、餐飲、會展及文創範疇多個社團的領導和代表昨日上午到特區政府政策研究室，表達對澳門特區參與《粵港澳大灣區城市群發展規劃》的意見和建議。政策研究室主任",
          content:"澳門旅遊、酒店、餐飲、會展及文創範疇多個社團的領導和代表昨日上午到特區政府政策研究室，表達對澳門特區參與《粵港澳大灣區城市群發展規劃》的意見和建議。政策研究室主任劉本立和副主任吳海恩認真聽取了意見。\n" +
              "\n" +
              "　　拓“一程多站”旅遊\n" +
              "\n" +
              "　　澳門旅遊零售服務業總商會理事長葉榮發，澳門旅遊業議會理事長胡景光，澳門旅遊管理學會會長張健中，澳門旅遊業工商聯會常務理事凌詠兒，澳門酒店協會主席王淑欣，澳門美食同業聯合商會理事長梁仕友，澳門中小型餐飲業商會理事長楊永成，澳門烹飪協會副會長胡達忠，澳門廣告商會會長黃義滿，澳門連鎖加盟商會會員大會主席黃仁民，澳門會議展覽業協會副會長關偉霖，澳門展貿協會秘書長鄧敏華，澳門會展專業管理協會會長曾鳴岐，青年創業智庫協會理事長吳偉恩，澳門漫畫從業員協會會長黃天俊，澳門文化創意產業發展協會秘書長劉陽子，澳門國際海洋經濟商會理事長周中余，代表所在社團表達了有關意見。\n" +
              "\n" +
              "　　上述社團領導和代表普遍認為，大灣區建設為促進澳門世界旅遊休閒中心建設提供了新的機遇，對澳門經濟社會可持續發展具有重要意義，同時需要正確處理大灣區城市間的合作與競爭關係，逐步破除合作中的障礙。代表們就今後澳門如何參與大灣區城市群建設提出了多方面意見，包括：強化自身比較優勢，促進大灣區城市間的差異化優勢互補發展；澳門應在專業培訓方面發揮更加積極作用，建設成為亞洲旅遊培訓中心和葡語國家會展人才培訓中心；聯合大灣區其他城市共同開發“一程多站”旅遊線路，將大灣區建設成為大旅遊目的地；推動跨境交通基礎設施的建設，創新通關模式，促進灣區城市間的人流、物流，等等。\n" +
              "\n" +
              "　　澳文化產業走出去\n" +
              "\n" +
              "　　也有代表建議，大灣區城市可考慮聯合申辦及舉行會展活動；透過與大灣區城市的合作，推動澳門文化產業“走出去”；檢討有關法律制度，推進科技創新；不斷完善人才政策，重視人力資源的培訓和中小企的人力短缺問題；重視海洋經濟，發展世遺旅遊；利用澳門優勢，建設“美食之都”；政府提供資訊服務，支持澳門企業和居民到灣區創業發展；要大力宣傳和弘揚澳門精神，增強特區精神軟實力。"
        }, {
          title:"澳門今年第四季重開社屋申請",
          title_content:"澳門特區立法會20日舉行全體大會，辯論重開社屋申請。列席會議的運輸工務司司長羅立文表示，今年第4季會開展新一期社屋申請，未來公屋會集中以大型屋邨形式興建。 持續的高樓價",
          content:"澳門特區立法會20日舉行全體大會，辯論重開社屋申請。列席會議的運輸工務司司長羅立文表示，今年第4季會開展新一期社屋申請，未來公屋會集中以大型屋邨形式興建。\n" +
              "\n" +
              "　　持續的高樓價和高租金下，澳門不少基層家庭對於社屋申請“望穿秋水”，但面對重開申請遙遙無期急如熱鍋螞蟻。在5月份舉行的立法會全體會議上，議員李靜儀就政府應立即開展社會房屋申請並落實社屋申請恒常機制提出辯論動議，獲得通過。\n" +
              "\n" +
              "　　羅立文在當天的辯論會上稱，今年第4季將會開展新一期社屋申請。他還透露，因為社屋輪候者已全部上樓，因此目前已沒有人收取輪候社屋住屋補貼。\n" +
              "\n" +
              "　　多位議員追問公屋需求研究報告的進度、今年第4季重開社屋申請的詳情、會否將社屋申請變成恒常機制等問題。羅立文回應指，公屋需求研究報告最遲今年10月完成；至於是否設立社屋申請恒常機制，他表示，修訂社屋法已於2016年12月進入立法程序，未來會提交立法會審議。"
        }, {
          title:"國際知名專家聚集澳門探討治癌新技術",
          title_content:"第四屆澳門生物醫學科學研討會＂21日在澳門大學揭幕，近300名海外國內知名的生物醫學專家、科研人員共聚一堂，就近期生物醫學重大的新技術、前沿研究深入交流和討論。 今屆研討",
          content:"“第四屆澳門生物醫學科學研討會＂21日在澳門大學揭幕，近300名海外國內知名的生物醫學專家、科研人員共聚一堂，就近期生物醫學重大的新技術、前沿研究深入交流和討論。\n" +
              "\n" +
              "　　今屆研討會以“創新＂為題，內容涵蓋生物醫學領域各重大議題，包括診斷造影和藥物傳輸、癌症免疫學、轉化試驗和個人化癌症療法、腫瘤微環境和轉移、新陳代謝、信令網和治療學、發展誘導、生物醫學新技術等。\n" +
              "\n" +
              "　　此外，研討會吸引衆國際著名的生物醫學學者出席并發表演說，包括美國加州大學聖塔芭芭拉分校教授Matthew Fisher，中山大學腫瘤防治中心副院長錢朝南、教授朱孝峰，韓國成均館大學教授Dong-Ki Lee，香港大學教授陳志峰，澳門大學教授劉子銘、李子安和潘全威等。\n" +
              "\n" +
              "　　“澳門生物醫學科學研討會＂自2014年至今已成功舉辦三屆，每年均邀請多名國際頂尖學者針對各主軸議題的研究發展進行演講分享，藉此聚集各地生物醫學領域的專家學者共同討論，加強學術交流與科研合作，促進生物醫學的創新與發展。(完)"
        }
        // , {
        //   title:"澳特首崔世安：輕軌氹仔段如期通車",
        //   center:"澳門特區政府指成立輕軌公司過程較預期複雜，為運建辦延續三年。有意見擔憂會影響輕軌通車進度。崔世安昨日受訪稱，未聽聞輕軌公司要三年後才能成立。認為現時進展順利，有信"
        // }
        // , {
        //   title:"培訓及考證後學員就業狀況調查” 資料收集期",
        //   center:"為瞭解完成職業培訓課程及技能測試的學員在職業發展上的效果，以作為特區政府開展應用人才培訓工作的參考，勞工事務局於本年4月開展了《培訓及考證後學員就業狀況調查》，調查"
        // }, {
        //   title:"行政長官：中央重視和支持澳門加快建設中葡平",
        //   center:"行政長官崔世安今（31）日出席央企支持澳門中葡平台建設高峰會時強調，澳門特區正積極融入國家發展，不斷發揮澳門所長，服務國家所需，實現共同發展，當中，發揮中葡平台作用"
        // }, {
        //   title:"文化局將出席第41屆世遺大會",
        //   center:"文化局將組團出席七月舉行的聯合國教科文組織世界遺產委員會第四十一屆大會。 世界遺產中心每年會按既定程序，將各締約國所提交之遺產地的保護狀況報告，經分析後交由世界遺產"
        // }, {
        //   title:"貿促局辦會展工作坊提升本地業界競爭力",
        //   center:"澳門貿易投資促進局於今(24)日在澳門商務促進中心舉辦「澳門會展工作坊 - 會展品牌建立及產品推廣」(Macao MICE Industry Workshop - Creating a MICE Brand and Product Offering)，吸引超過50位來自本澳"
        // },
      ]
    }
  },
  created() {

  },
  methods: {
    /*主键函数*/
    onMenuSelect(index, indexPath) {
      console.log('选中菜单:', index, indexPath)
    },
    hrefNoticeUrl(row){
      var then=this;
      then.$router.replace({
        name: 'newsNoticeInfo',
        query: row
      })
    },
    showFun(type,title){
      this.dialogVisible=type
      this.title=title
    },
    hrefUrl(url) {
      window.location.href = url;
    },
    routerUrl(url) {
      this.$router.replace(url);
    },


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  padding: 0;
  overflow-y: auto;
  justify-items: center;
  overflow-y: auto;
}

.contentDiv {
  padding: 0;
  background: rgb(4, 23, 65);
  /*background-image: url("../assets/bgvideo.webp");*/
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  width: 100%;
  height: 100%;
  /*display: flex;*/
  align-items: center; /*定义父元素的元素垂直居中*/
  justify-content: center; /*定义子元素的里的元素水平居中*/
  text-align: center;
}

.horizontal-nav li {
//margin: 0 15px; //padding: 8px 16px; color: white;
  border-radius: 4px;
}


.responsive-left, .responsive-right {
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 20px;
}


.responsive-left {
  text-align: left;
}


.list_ti {
  background: #1e2c51;
  padding: 10px 10px;
}
.list_ti .lst {
  padding: 5px 10px;
  height: 89px;
  background: #fff;
  margin: 0 auto;
  border-radius: 5px;
}
.list_ti .blank {
  width: 100%;
  height: 10px;
  overflow: hidden;
  background: #1e2c51;
  margin: 0px;
  padding: 0px;
}
.list_ti .lst dl {
  height: 28px;
  line-height: 28px;
  overflow: hidden;
  margin: 0px;
}
.list_ti .lst dl dt a {
  color: #1a63b5;
}
.list_ti .lst dl dt {
  float: left;
  font-size: 14px;
  font-weight: bold;
}
/**
页脚
 */
footer .foot_con {
  padding: 15px 0;
  color: #4e6692;
  font-size: 12px;
}

.pub_case {
  margin-left: auto;
  margin-right: auto;
}

footer .link_foo {
  float: right;
}

footer .copyRight {
  float: left;
}

footer .foot_con a {
  color: #4e6692;
}
@media (max-width:500px) {

  .link_foo{
    font-size: 4px;
  }

  .copyRight{
    font-size: 4px;
  }
  .lst01{
    font-size: 10px;
  }
  .logo111{
    position: absolute;
    margin-top: 14px !important;
    width: 100px;
  }
  .el-row{
    width: auto !important;
  }
}


</style>

